const paths = {
  main: '/stocks',
  detail: '/stocks/:stockId',
  create: '/stocks/create',
};

export default paths;
